import axios from 'axios';
import {API} from "@/services/url";
import {getOrFetch, invalidate} from "@/services/cache";

export default {
	getModuleList: (success, error) => {
		// Modules change rarely (admin-only CRUD) — cache the list client-side for 2 min
		// to cut repeat calls across views. storeModule() below clears it on write.
		getOrFetch('moduleList', 120000, () => axios.get(API.modules.moduleList)).then(
			r => success(r.data.modules)
		).catch(
			e => error(e.response.data.message)
		);
	},
	storeModule: (module, success, error) => {
		axios.post(API.modules.moduleStore, module)
			.then(
				r => {
					invalidate('moduleList');
					success(r.data)
				}
			).catch(
			e => error(e.response.data.message)
		);
	}
}
